import { mapState } from 'vuex';
import { CardBlock } from '@/cms/definitions/content-types';
import { DogSettings } from '../dog/DogSettings';
import { FamilySettings } from '../family/FamilySettings';
import { HomeSettings } from '../home/HomeSettings';
import { HouseSettings } from '../house/HouseSettings';
import { TravelSettings } from '../travel/TravelSettings';
import { Options, Vue } from 'vue-class-component';
import { CarSettings } from '../car/CarSettings';
import { AccidentSettings } from '../accident/AccidentSettings';
import { getSuggestText, getSuggestText1, setSuggestText } from '../services/SuggestProductService';

@Options({
	name: 'OverviewStepComponent',
	components: {},
	computed: mapState<any>({
		model: (state) => state.calculatorContext[state.calculatorContext.active].model,
		cms: (state) => state.calculatorContext[state.calculatorContext.active].cms,
	}),
	props: {
		card: Object, // Card from cms
		isValid: Boolean, // wether card is complete
	},
})
export default class OverviewStepComponent extends Vue {
	card: CardBlock; // Card from cms
	isValid: boolean; // wether card is complete

	public model!: any; // datastructure for user input (store)
	public cms!:
		| DogSettings
		| TravelSettings
		| CarSettings
		| AccidentSettings
		| HomeSettings
		| HouseSettings
		| FamilySettings; // settings from CMS (store)

	public showOrderDetails = false;
	public coverages: any = null; // coverages on selected package

	public suggest: { suggestedProducts: string; discountDisplay: string } = {
		suggestedProducts: undefined,
		discountDisplay: undefined,
	};
	public suggestText: string = null;
	public suggestText1: string = null;

	public created() {
		if (this.model.choosePackage.selectedPackage.expandedCoverages?.length > 0) {
			this.coverages = [];
			this.model.choosePackage.selectedPackage.expandedCoverages.forEach((name) => {
				this.coverages.push({ name });
			});
		} else {
			this.coverages = this.model.choosePackage.selectedPackage.coverages;
		}
		this.setSuggestText();
	}

	public mounted(): void {
		addEventListener('keyup', this.moveOn);
	}

	public beforeUnmount() {
		removeEventListener('keyup', this.moveOn);
	}

	public moveOn(evt) {
		if (evt.keyCode === 13 && this.isValid) {
			this.nextStep();
		}
	}

	private setSuggestText() {
		setSuggestText(this, this.cms);
	}
	public getSuggestText(): string {
		return getSuggestText(this, this.cms);
	}
	public getSuggestText1(): string {
		return getSuggestText1(this, this.cms);
	}

	public toggleOrderDetails() {
		this.showOrderDetails = !this.showOrderDetails;
	}

	public nextStep() {
		this.$emit('nextStep', this.card.routePath);
	}

	public getMonthlyYearlyPrices(monthly: boolean) {
		const pack = this.model.choosePackage.selectedPackage;
		return monthly ? pack.totalPriceDisplay + ' / pr. md.' : pack.yearlyPriceTotalDisplay + ' årligt';
	}

	public gotoAddInsurances() {
		this.$emit('gotoAddInsurances', this.card.name);
	}
}
